import { concat, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { getLotMapInventory$ } from '../apis/getLotMapInventory';
import processLotMapInventory from '../services/processLotMapInventory';

/**
 * Factory that returns a redux-observable epic scoped to a specific community.
 *
 * Triggers on fetchSiteMapSuccess so the lot inventory fetch starts only after
 * state.lots is populated with site-plan lots. This guarantees that the enrich
 * merge in fetchLotInventorySuccess reducer always has lots to merge into.
 *
 * take(1) ensures exactly one lot inventory fetch per page load.
 *
 * @param {object} params
 * @param {number} params.communityId
 * @param {object} params.dataActions - Actions from the feature data slice instance
 * @returns {import('redux-observable').Epic}
 */
function createFetchLotInventoryEpic({ communityId, dataActions }) {
  return (action$) => action$.pipe(
      // Intentional: gating on fetchSiteMapSuccess guarantees state.lots is
      // populated before fetchLotInventorySuccess enriches it. Starting the
      // HTTP request earlier with shareReplay(1) would save a round-trip but
      // complicates error handling when inventory errors before the site-map lands.
      ofType(dataActions.fetchSiteMapSuccess.type),
      take(1),
      switchMap(() =>
        concat(
          of(dataActions.fetchLotInventory()),
          getLotMapInventory$(communityId).pipe(
            map(processLotMapInventory),
            map((inventory) => dataActions.fetchLotInventorySuccess(inventory)),
          ),
        ).pipe(
          catchError((err) => of(dataActions.fetchLotInventoryError(err.message))),
        ),
      ),
    );
}

export default createFetchLotInventoryEpic;
